"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = void 0;

var _constants = require("./constants");

const logger = (() => {
  const ddTok = 'pubb96b84a13912504f4354f2d794ea4fab';
  let isTelemetryEnabled = undefined !== 'test';

  const log = async (message, level, attributes = {}) => {
    if (!isTelemetryEnabled) {
      return;
    }

    try {
      var _document, _window, _window$location, _window2, _window2$location, _navigator;

      let env;

      if (_constants.DEFAULT_BASE_URL.includes('localhost')) {
        env = 'local';
      } else if (_constants.DEFAULT_BASE_URL.includes('dev')) {
        env = 'dev';
      } else {
        env = 'prod';
      }

      const payload = {
        // dd info
        level,
        message,
        // for basis theory tracking
        service: 'js-sdk',
        env,
        // browser information
        referrer: (_document = document) === null || _document === void 0 ? void 0 : _document.referrer,
        origin: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin,
        url: (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href,
        userAgent: (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent,
        // custom values
        ...attributes
      };
      await fetch(`https://http-intake.logs.datadoghq.com/v1/input/${ddTok}`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } catch {
      // eslint-disable-next-line no-console
      console.warn('There was an error sending telemetry.');
    }
  };

  const setTelemetryEnabled = enabled => {
    isTelemetryEnabled = enabled;
  };

  return {
    setTelemetryEnabled,
    log: {
      error: (message, attributes = {}) => log(message, 'error', attributes),
      info: (message, attributes = {}) => log(message, 'info', attributes),
      warn: (message, attributes = {}) => log(message, 'warn', attributes)
    }
  };
})();

exports.logger = logger;